<template>
    <div class="tm-scope tp-privacy">
        <div class="row my-5 mx-auto tm-container tm-container--text">
            <div class="tm-card p-5">
                <h4><strong>Privacy Policy</strong></h4>
                <br>
                <strong>Effective Date: {{new Date().getFullYear()}}/{{new Date().getMonth()+1}}/{{new Date().getDate()}}</strong>
                <br>
                <div class="d-inline">
                    <strong>Topment</strong> values your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application. Please read this policy carefully to understand our views and practices regarding your personal data.
                </div>
                <br><br>
                <h4><strong>Information We Collect</strong></h4>
                <br>
                <h5><strong>1. Information You Provide</strong></h5>
                <div class="d-inline">
                    <strong>- Account Information:</strong> When you sign in using Google Authentication, we collect your basic profile information, including your name, email address, and profile picture.
                </div>
                <br>
                <div class="d-inline">
                    <strong>- Optional Information:</strong>If you choose to provide additional information (e.g., settings or preferences), we may store and use it to enhance your experience.
                </div>
                <br>
                <br>
                <h5><strong>2. Automatically Collected Information</strong></h5>
                <br>
                <div class="d-inline">
                    <strong>- Device Information:</strong> We may collect information about your device, including its model, operating system, and unique device identifiers.
                </div>
                <br>
                <div class="d-inline">
                    <strong>- Usage Data:</strong> We may collect information about how you use the App, including access times, pages viewed, and interactions with features.
                </div>
                <br>
                <div class="d-inline">
                    <strong>- Log Data:</strong> When you use the App, we may log technical information such as your IP address and browser type.
                </div>
                <br><br>
                <h4><strong>How We Use Your Information</strong></h4>
                <br>
                We use the collected information to:
                <strong>- Provide, operate, and improve the App.</strong>
                <strong>- Authenticate and secure your account.</strong>
                <strong>- Personalize your experience.</strong>
                <strong>- Communicate with you regarding updates, features, and support.</strong>
                <strong>- Comply with legal and regulatory requirements.</strong>
                <br><br>
                <h4><strong>Information Sharing and Disclosure</strong></h4>
                <br><br>
                We do not sell your personal information. However, we may share your information with:
                <div class="d-inline">
                    <strong>- Service Providers:</strong> Third-party services that help us operate and maintain the App.
                </div>
                <div class="d-inline">
                    <strong>- Legal Compliance:</strong> Authorities if required by law or to protect rights, property, or safety.
                </div>
                <div class="d-inline">
                    <strong>- Consent-Based Sharing:</strong> With your explicit consent for specific purposes.
                </div>
                Be aware that we give you the option to reject the collection of your information in the cookie settings.
                <br><br>
                <br>
                <h4><strong>Data Security</strong></h4>
                We implement appropriate technical and organizational measures to safeguard your data. However, no method of electronic transmission or storage is 100% secure. We encourage you to take precautions to protect your personal information.
                <br><br><br>
                <h4><strong>Third-Party Services</strong></h4>
                Our App may integrate with third-party services, including Google Authentication. Please review their privacy policies to understand how they handle your data.
                <br><br>
                <h4><strong>Your Rights and Choices</strong></h4>
                <br>
                You have the right to:
                <strong>- Access and update your information.</strong>
                <strong>- Request the deletion of your data.</strong>
                <strong>- Withdraw consent where applicable.</strong>
                <br>
                To exercise these rights, contact us at <a href="mailto:admin@topment.fr">admin@topment.fr</a>
                <br><br><br>
                <h4><strong>Changes to This Privacy Policy</strong></h4>
                We may update this Privacy Policy from time to time. Any changes will be effective upon posting the revised policy in the App. We encourage you to review this policy periodically.
                <br><br><br>
                <h4><strong>Contact Us</strong></h4>
                If you have any questions or concerns about this Privacy Policy, please contact us at:
                <br>
                Topment.fr, <a href="mailto:admin@topment.fr">admin@topment.fr</a>
                <br><br>
                Thank you for trusting us with your personal information. Your privacy is important to us.
            </div>
        </div>
    </div>
</template>

<style scoped>
.tp-privacy {
    background: var(--tm-canvas);
    min-height: 100dvh;
    padding: 48px 16px;
    color: var(--tm-ink-soft);
}

.tp-privacy :deep(a) {
    color: var(--tm-accent-bright);
}
</style>